import { branchPlatform as bp, noop, promisify } from '@/libs/util'
import { buildPurchaserInfo, createOfferings } from './factories'

export default ({ purchasesAPI: api }) => {
  const getPurchaserInfo = async (user) => {
    const subscriber = await getSubscriber(user)
    return buildPurchaserInfo(subscriber)
  }

  const getSubscriber = async (user) => {
    const token = await user.getIdToken()
    const { body } = await api.getSubscriber(token)
    return body.data
  }

  const getOfferings = async () => {
    const { body } = await api.getOfferings()
    return createOfferings(body.data)
  }

  return {
    setDebugLogsEnabled: (...args) =>
      bp({
        native: () => Purchases.setDebugLogsEnabled(...args),
        browser: noop
      }),
    setup: (...args) =>
      bp({
        native: () => Purchases.setup(...args),
        browser: noop
      }),
    getOfferings: (...args) =>
      bp({
        native: () => promisify(Purchases.getOfferings)(...args),
        browser: () => getOfferings()
      }),
    getPurchaserInfo: (user) =>
      bp({
        native: promisify(Purchases.getPurchaserInfo.bind(Purchases)),
        browser: () => (user ? getPurchaserInfo(user) : Promise.resolve(null))
      }),
    logIn: (user) =>
      bp({
        native: async () => {
          const { purchaserInfo } = await promisify(Purchases.logIn)(user.uid)
          return purchaserInfo
        },
        browser: () => getPurchaserInfo(user)
      }),
    purchasePackage: (...args) =>
      bp({
        native: () => promisify(Purchases.purchasePackage, 1)(...args),
        browser: () => Promise.resolve({})
      }),
    reset: () =>
      bp({
        native: () => promisify(Purchases.reset)(),
        browser: () => Promise.resolve()
      })
  }
}
